import React from 'react';
import { toast } from 'react-toastify';

const TemplateManagerSection = ({ 
  type, // 'email', 'sms', 'layout'
  templates, 
  onNew, 
  onEdit, 
  onDelete,
  icon = '📄',
  title = 'Templates'
}) => {
  
  const getTypeName = (templateType) => {
    const types = {
      // Email
      'Notificacao': 'Notificação',
      'Fatura': 'Fatura',
      'Recibo': 'Recibo',
      'Documento': 'Documento',
      'Marcacao': 'Marcação',
      'Plano': 'Plano de Treino',
      'ContaCorrente': 'Conta Corrente',
      'Pendentes': 'Pendentes',
      // SMS
      'Agendamento': 'Agendamento',
      'PlanoTreino': 'Plano de Treino',
      'PlanoAlimentar': 'Plano Alimentar',
      // Layout
      'FT': 'Fatura',
      'RC': 'Recibo',
      'GR': 'Guia Remessa',
      'MS': 'Movimento Stock',
      'INV': 'Inventário'
    };
    return types[templateType] || templateType;
  };

  return (
    <section className="settings-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>
          <span className="section-icon">{icon}</span>
          {title}
        </h2>
        <button 
          className="btn-primary"
          onClick={onNew}
          style={{ fontSize: '14px', padding: '10px 20px' }}
        >
          + Novo Template
        </button>
      </div>

      {templates.length === 0 ? (
        <div style={{ 
          padding: '40px', 
          textAlign: 'center', 
          background: '#f9fafb', 
          borderRadius: '12px',
          border: '2px dashed #d1d5db'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📭</div>
          <p style={{ color: '#6b7280', marginBottom: '16px' }}>
            Nenhum template criado ainda
          </p>
          <button className="btn-secondary" onClick={onNew}>
            Criar Primeiro Template
          </button>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {templates.map(template => (
            <div 
              key={template.id}
              style={{
                padding: '20px',
                background: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'all 0.2s',
                cursor: 'pointer'
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                  <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                    {template.name}
                  </h3>
                  {template.isDefault && (
                    <span style={{
                      padding: '4px 8px',
                      background: '#dbeafe',
                      color: '#1e40af',
                      borderRadius: '6px',
                      fontSize: '11px',
                      fontWeight: '600'
                    }}>
                      ⭐ PADRÃO
                    </span>
                  )}
                  {!template.isActive && (
                    <span style={{
                      padding: '4px 8px',
                      background: '#fee2e2',
                      color: '#991b1b',
                      borderRadius: '6px',
                      fontSize: '11px',
                      fontWeight: '600'
                    }}>
                      ⏸️ INATIVO
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '16px', fontSize: '13px', color: '#6b7280' }}>
                  <span>
                    <strong>Tipo:</strong> {getTypeName(template.type || template.documentType)}
                  </span>
                  {template.subject && (
                    <span>
                      <strong>Assunto:</strong> {template.subject.substring(0, 50)}
                      {template.subject.length > 50 && '...'}
                    </span>
                  )}
                  {template.paperSize && (
                    <span>
                      <strong>Papel:</strong> {template.paperSize}
                    </span>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => onEdit(template)}
                  title="Editar"
                  style={{ 
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '18px',
                    padding: '8px',
                    color: '#3b82f6',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                >
                  ✏️
                </button>
                {template.isDefault && (
                  <button
                    title="Template Padrão"
                    style={{ 
                      background: 'none',
                      border: 'none',
                      cursor: 'default',
                      fontSize: '18px',
                      padding: '8px',
                      color: '#fbbf24'
                    }}
                  >
                    ⭐
                  </button>
                )}
                <button
                  onClick={() => {
                    if (window.confirm(`Tem certeza que deseja eliminar "${template.name}"?`)) {
                      onDelete(template.id);
                    }
                  }}
                  title="Eliminar"
                  style={{ 
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '18px',
                    padding: '8px',
                    color: '#ef4444',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default TemplateManagerSection;
